import axios from 'axios'
import { Base64 } from 'js-base64'
import { Toast } from 'vant'
import qs from 'qs'
import api from './api'
import router from '../router'
import i18n from '../lang'

const instance = axios.create({
  baseURL: '/api',
  timeout: 5000,
  withCredentials: false,
})

instance.interceptors.request.use((config) => {
  config.headers = config.headers || {}
  if (config.method === 'post') {
    config.headers['content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  }
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.token = Base64.encode(token)
  }
  config.headers.lang = i18n.locale || localStorage.getItem('language') || 'en-us'
  return config
})

function decodeResult(res) {
  const result = res.data
  result.data = JSON.parse(Base64.decode(result.data))
  return result
}

function handleAuthFail(result) {
  if (!result || result.code !== 401) return
  const path = router.currentRoute.path
  if (path === '/Login' || path === '/Register') return
  const lang = i18n.locale || localStorage.getItem('language') || 'en-us'
  localStorage.clear()
  localStorage.setItem('language', lang)
  Toast(result.msg || i18n.t('请求.请重新登录'))
  router.replace({ path: '/Login' })
}

async function http(option = {}) {
  const { method, url, data } = option
  let result = null
  try {
    if (method === 'get' || method === 'delete') {
      result = decodeResult(await instance[method](api[url], { params: data }))
    } else if (method === 'post' || method === 'put') {
      result = decodeResult(await instance[method](api[url], qs.stringify(data)))
    }
  } catch (err) {
    result = err
  }
  handleAuthFail(result)
  return result
}

export default http
